<section class="content">
    <div class="content-block">
        <app-header-menu></app-header-menu>
        <div class="block-header">
            <app-breadcrumb [title]="'Dashboard'" [module]="'Master'" [subModule]="'General Master'"
                [moduleLink]="'/admin/dashboar-module'" [items1]="['Add Store']"
                [itemLink]="'/coremodule/Addstoretype'"></app-breadcrumb>
        </div>
        <div *ngIf="isLoading" class="loader-overlay">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        <div class="row clearfix main-contain-body">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card">
                    <div class="body">
                        <div class="example-button-row mb-3">
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'StoreLocation']" routerLinkActive="primary-color">
                                View Store Type
                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Addstoretype']" routerLinkActive="primary-color">
                                Add Store Type

                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Viewstore']" routerLinkActive="primary-color">
                                View Stores
                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Addstorelocation']" routerLinkActive="primary-color">
                                Add Store

                            </button>

                        </div>

                        <div class="header">
                            <h1 class="my-class">Add Store </h1>
                        </div>

                        <form class="register-form m-4" [formGroup]="storeForm" (ngSubmit)="onSubmit()">
                            <div class="row">

                                <!-- Business Unit -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <!-- <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Business Unit</mat-label>
                                        <mat-select formControlName="Businessunit">
                                            <mat-option value="HMHBBS">HMHBBS</mat-option>
                                            <mat-option value="HDHBBS">HDHBBS</mat-option>
                                        </mat-select>
                                    </mat-form-field> -->
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Business Unit</mat-label>
                                        <mat-select formControlName="Businessunit" required>
                                            <mat-option *ngFor="let bis of BusinessArea"
                                                [value]="bis.businessAreaId">{{bis.businessUnitName}}({{bis.aliasName}})</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Store Type – Dynamic Dropdown -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Store Type</mat-label>
                                        <mat-select formControlName="Storetype" required>
                                            <mat-option *ngFor="let s of storeTypes" [value]="s.storeTypeId">
                                                {{ s.storeType }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Store Type</mat-label>
                                        <mat-select formControlName="Storetype" required>
                                            <mat-option [value]="1">Department Store </mat-option>
                                            <mat-option [value]="2">Sub - Store </mat-option>
                                            <mat-option [value]="3">Central Store </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> -->
                                <!-- Store Name -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Store Name</mat-label>
                                        <input matInput formControlName="Skuname">
                                    </mat-form-field>
                                </div>

                                <!-- Store Description -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Store Description</mat-label>
                                        <input matInput formControlName="Sdescription">
                                    </mat-form-field>
                                </div>

                                <!-- Store Location -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Store Location</mat-label>
                                        <input matInput formControlName="Slocation">
                                    </mat-form-field>
                                </div>

                                <!-- Building Name -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Building Name</mat-label>
                                        <input matInput formControlName="Bname">
                                    </mat-form-field>
                                </div>

                                <!-- Floor Name -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Floor Name</mat-label>
                                        <input matInput formControlName="Fname">
                                    </mat-form-field>
                                </div>

                                <!-- Size of Store -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Size of the Store</mat-label>
                                        <input matInput formControlName="sos">
                                    </mat-form-field>
                                </div>

                                <!-- Contact Name -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Contact Name</mat-label>
                                        <input matInput formControlName="Cname">
                                    </mat-form-field>
                                </div>

                                <!-- Contact No -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Contact No</mat-label>
                                        <input matInput formControlName="Cno">
                                    </mat-form-field>
                                </div>

                                <!-- Email -->
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Email</mat-label>
                                        <input matInput formControlName="email">
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- BUTTONS -->
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-1"
                                    style="text-align: right; margin-top: 2%;">

                                    <button class="btn-space" mat-raised-button color="primary" type="submit">
                                        Submit
                                    </button>

                                    <button class="btn-space" mat-raised-button color="accent" type="button"
                                        (click)="onReset()">
                                        Reset
                                    </button>

                                    <button class="btn-space" mat-raised-button color="warn" type="button">
                                        Back
                                    </button>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    </div>
</section>